module.exports = __webpack_public_path__ + "static/media/60-r-en.737cf588.png";